
    export const init_efectivo = (
        idElement,
        total_bs_user_terminal,
        total_usd_user_terminal,
        //total_bs_user_seguro,
        //total_usd_user_seguro,
        order_id,
        userFunc) => {

        const tableId = (idElement=='PagoEfectivo')?'PagoEfectivo':'PagoEfectivo_seguro';
        const botonId = (idElement=='PagoEfectivo')?'pago_efectivo':'pago_efectivo_seguro';
        $(`#tbody${tableId}`).empty();
        const tableBody = document.getElementById(`table${tableId}`).getElementsByTagName('tbody')[0];

        let row = tableBody.insertRow(0);
        // Insert new cells (<td> elements) at the 1st and 2nd position of the "new" <tr> element:
        let cell0 = row.insertCell(0);
        let cell1 = row.insertCell(1);
        let cell2 = row.insertCell(2);
        // Add some text to the new cells:
        cell0.innerHTML = 'PAGOS EN EFECTIVO';
        cell1.innerHTML = total_bs_user_terminal;
        cell2.innerHTML = total_usd_user_terminal;
        /*if (total_bs_user_seguro) {

            row = tableBody.insertRow(1);
            // Insert new cells (<td> elements) at the 1st and 2nd position of the "new" <tr> element:
            cell0 = row.insertCell(0);
            cell1 = row.insertCell(1);
            cell2 = row.insertCell(2);
            // Add some text to the new cells:
            cell0.innerHTML = 'SEGURO';
            cell1.innerHTML = total_bs_user_seguro;
            //cell2.innerHTML = total_usd_user_seguro;
        }*/

        $(`#${botonId}`).click(async function(){
            //console.log('hola')
            var fileInput = (idElement=='PagoEfectivo')?document.getElementById(`pago_efectivo_file`).files.length:document.getElementById(`pago_efectivo_seguro_file`).files.length; // consider giving this an id too

            if(fileInput && fileInput !== '') {
                const fileSize =(idElement=='PagoEfectivo')?document.getElementById(`pago_efectivo_file`).files[0].size:document.getElementById(`pago_efectivo_seguro_file`).files[0].size; // consider giving this an id too
                const siezekiloByte = parseInt(fileSize / 1024);
                //console.log(siezekiloByte)
                if(siezekiloByte < 4000) {
                    document.getElementById(`${botonId}`).disabled = true;

                    var form = (idElement === 'PagoEfectivo') ? document.getElementById("efectivo_form") :
                        document.getElementById("efectivo_form_seguro");
                    var formData = new FormData(form);
                    formData.append("referencia", 'EFECTIVO')
                    formData.append("estatus_order", 5)
                    formData.append("order", order_id)
                    formData.append("metodo_pago", "EFECTIVO")
                    $.ajax({
                        url: '/api/pagos/callback/cdn',
                        type: "POST",
                        cache: false,
                        contentType: false,
                        processData: false,
                        method: 'POST',
                        data: formData,
                        error: function (XMLHttpRequest, textStatus, errorThrown) {
                            console.log("EFECTIVO Status: " + textStatus);
                            console.log("Error: " + errorThrown);
                            $(`#${tableId}`).modal('toggle');
                            return userFunc({
                                data: false
                            });
                        }
                    }).then(() => {
                        $(`.${tableId}`).modal('toggle');
                        return userFunc({
                            data: true
                        });
                    });
                }else {
                    Swal.fire({
                        icon: 'error',
                        title: 'Oops...',
                        text: 'El soporte de pago no debe ser mayor a 4MB'
                    })
                }
            }else{
                Swal.fire({
                    icon: 'error',
                    title: 'Oops...',
                    text: 'Debes adjuntar el soporte de pago'
                })
            }

        });
    };
